import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\CampaignController::unsubscribe
* @see app/Http/Controllers/Creator/CampaignController.php:657
* @route '/app/creator/campaigns/recipients/unsubscribe'
*/
export const unsubscribe = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unsubscribe.url(options),
    method: 'post',
})

unsubscribe.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/recipients/unsubscribe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::unsubscribe
* @see app/Http/Controllers/Creator/CampaignController.php:657
* @route '/app/creator/campaigns/recipients/unsubscribe'
*/
unsubscribe.url = (options?: RouteQueryOptions) => {
    return unsubscribe.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::unsubscribe
* @see app/Http/Controllers/Creator/CampaignController.php:657
* @route '/app/creator/campaigns/recipients/unsubscribe'
*/
unsubscribe.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unsubscribe.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::unsubscribe
* @see app/Http/Controllers/Creator/CampaignController.php:657
* @route '/app/creator/campaigns/recipients/unsubscribe'
*/
const unsubscribeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsubscribe.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::unsubscribe
* @see app/Http/Controllers/Creator/CampaignController.php:657
* @route '/app/creator/campaigns/recipients/unsubscribe'
*/
unsubscribeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsubscribe.url(options),
    method: 'post',
})

unsubscribe.form = unsubscribeForm

const recipients = {
    unsubscribe: Object.assign(unsubscribe, unsubscribe),
}

export default recipients